import Swiper, { Navigation, Pagination } from 'swiper';
// Navigationを登録
Swiper.use([Navigation]);
import '../css/index.css';

document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll<HTMLButtonElement>(
    '[data-role^="btn-area-"]'
  );
  const sections = document.querySelectorAll<HTMLElement>(
    '[data-role^="area-"]'
  );

  /**
   * エリアを切り替える関数
   * @param targetId "area-japan" などの ID
   */
  const switchArea = (targetId: string): void => {
    // 1. すべてのセクションから active クラスを除去
    sections.forEach((section) => {
      section.classList.remove('is-active');

      // 対象のデータ属性を持つセクションにのみクラスを付与
      if (section.getAttribute('data-role') === targetId) {
        section.classList.add('is-active');
      }
    });
  };

  // すべてのボタンに対してクリックイベントを設定
  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      const btnRole = button.getAttribute('data-role');
      if (!btnRole) return;

      // "btn-area-xxx" から "area-xxx" を抽出
      const targetId = btnRole.replace('btn-', '');
      switchArea(targetId);
    });
  });

  // 初期表示（JAPAN）の設定
  switchArea('area-japan');

  /*-----------------
    map-area
  -----------------*/
  const swiperElement = document.querySelector(
    '[data-role="top-map-swiper"]'
  ) as HTMLElement;
  if (!swiperElement) return;

  const swiper = new Swiper(swiperElement, {
    slidesPerView: 1,
    spaceBetween: 8,
    observer: true,
    observeParents: true,
    updateOnWindowResize: true,
    // --- 追加: ナビゲーションの設定 ---
    navigation: {
      nextEl: '.top-map-swiper-nav-next',
      prevEl: '.top-map-swiper-nav-prev',
    },
    // ------------------------------
    on: {
      init: function (swiper) {
        if (typeof swiper.update === 'function') {
          swiper.update();
        }
      },
    },
  });

  const container = document.querySelector('[data-role="area-niigata"]');

  // アクティブクラス更新
  const updateActiveClass = (role: string) => {
    if (!container) return;
    const allInteractiveElements = container.querySelectorAll('[data-role]');
    allInteractiveElements.forEach((el) => {
      const elRole = el.getAttribute('data-role');
      // 地図パーツなどのアクティブ状態を切り替え
      if (elRole && !elRole.startsWith('area-')) {
        el.classList.toggle('is-active', elRole === role);
      }
    });
  };

  // --- A. スワイプ連動 ---
  swiper.on('slideChange', () => {
    const activeSlide = swiper.slides[swiper.activeIndex];
    const slideRole = activeSlide?.getAttribute('data-role');
    if (slideRole) {
      // 'area-murakami' -> 'murakami' に変換してクラス更新
      const role = slideRole.replace('area-', '');
      updateActiveClass(role);
    }
  });

  // --- B. クリック連動 (SVGパーツ & ボタン) ---
  container?.addEventListener('click', (e: Event) => {
    const target = e.target as Element;
    const targetRoleEl = target.closest('[data-role]');
    if (!targetRoleEl) return;

    const role = targetRoleEl.getAttribute('data-role');

    if (role && !role.startsWith('area-')) {
      const targetId = `area-${role}`;
      const slides = Array.from(
        swiperElement.querySelectorAll('.swiper-slide')
      );
      const targetIndex = slides.findIndex(
        (s) => s.getAttribute('data-role') === targetId
      );

      if (targetIndex !== -1) {
        swiper.slideTo(targetIndex);
      }
    }
  });

  // 初回実行
  setTimeout(() => {
    swiper.update();
    // 初期状態に合わせてアクティブクラスを付与
    const initialSlide = swiper.slides[swiper.activeIndex];
    const initialRole = initialSlide
      ?.getAttribute('data-role')
      ?.replace('area-', '');
    if (initialRole) {
      updateActiveClass(initialRole);
    }
  }, 300);
  /*----------------
    season slide
  ----------------*/
  // 2. ボタンの取得
  const seasonButtons = document.querySelectorAll<HTMLButtonElement>(
    'button[data-role^="btn-"]'
  );

  /**
   * 現在のスライドのdata-roleを見て、対応するボタンをアクティブにする関数
   */
  function updateActiveButtonByRole(swiper: any) {
    const activeSlide = swiper.slides[swiper.activeIndex] as HTMLElement;
    if (!activeSlide) return;

    const slideRole = activeSlide.getAttribute('data-role');
    if (!slideRole) {
      seasonButtons.forEach((btn) => btn.classList.remove('is-active'));
      return;
    }
    const currentSeason = slideRole.replace('slide-', '');

    seasonButtons.forEach((btn) => {
      const btnSeason = btn.getAttribute('data-role')?.replace('btn-', '');
      if (btnSeason === currentSeason) {
        btn.classList.add('is-active');
      } else {
        btn.classList.remove('is-active');
      }
    });
  }

  // 1. Swiperの初期化
  const reasonSwiper = new Swiper('[data-role="top-season-swiper"]', {
    loop: false,
    speed: 600,
    // --- 追加: ナビゲーションの設定 ---
    navigation: {
      nextEl: '.top-season-swiper-nav-next', // 任意のクラス名に調整してください
      prevEl: '.top-season-swiper-nav-prev',
    },
    // ------------------------------
    on: {
      init: function (swiper) {
        updateActiveButtonByRole(swiper);
      },
      slideChange: function (swiper) {
        updateActiveButtonByRole(swiper);
      },
    },
  });

  // 3. ボタンクリック時の処理
  seasonButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const role = btn.getAttribute('data-role');
      if (!role) return;

      const season = role.replace('btn-', '');
      const targetSlide = document.querySelector<HTMLElement>(
        `[data-role="slide-${season}"]`
      );

      if (targetSlide) {
        const index = reasonSwiper.slides.indexOf(targetSlide);
        if (index !== -1) {
          reasonSwiper.slideTo(index);
        }
      }
    });
  });

  const closeButton = document.querySelector<HTMLButtonElement>(
    '[data-role="emergency-close"]'
  );
  const emergencyBox = document.querySelector<HTMLElement>(
    '[data-role="emergency-box"]'
  );

  // 要素が存在する場合のみ処理を登録
  if (closeButton && emergencyBox) {
    closeButton.addEventListener('click', () => {
      // Tailwindの 'hidden' クラスを追加して非表示にする
      emergencyBox.classList.add('hidden');

      // もし完全にDOMから消したい場合は remove() を使用
      // emergencyBox.remove();
    });
  }
});
